import React, { useEffect, useLayoutEffect, useState } from "react";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {
  CHART_COLORS,
  CHART_COLORS_THREE,
  CHART_MAX_VALUES,
  productColors,
  RANDOM_CHART_COLORS,
} from "constant/variables";

am4core.useTheme(am4themes_animated);

export default function BulletPieChartOutlet(props) {
  const [viewData, setViewData] = useState([]);
  const { outletper, isMyPerformance, selectedRegion } = props;

  console.log("BulletPieChartOutlet Render", outletper);

  useEffect(() => {
    if (outletper) {
      if (outletper.length === 0) {
        const viewDetail = [];
        const details = {
          country: "Data Not Available",
          units: 0,
          second: 0,
        };
        viewDetail.push(details);
        setViewData(viewDetail);
      } else {
        const clinic = outletper;
        const viewDetail = [];
        let count = 0;
        console.log("BulletPieChartOutlet useEffect", outletper);
        for (let index = 0; index < clinic.length; index++) {
          if (count + 1 > CHART_MAX_VALUES) {
            break;
          }
          if (props.region && props.region !== clinic[index].Region) {
          } else {
            const details = {
              country: clinic[index].OutletName,
              litres: clinic[index].TotalSales,
              target: clinic[index].TotalTarget,
              achieved_percentage: clinic[index].TotalAchievedPercentage,
              color: RANDOM_CHART_COLORS[count],
              subData: [
                {
                  value: clinic[index].BaqatiSales,
                  name: "Baqati",
                  target: clinic[index].BaqatiTarget,
                  achieved_percentage: clinic[index].BaqatiAchievedPercentage,
                  color: productColors.Baqati,
                },
                {
                  value: clinic[index].HayyakSales,
                  name: "Hayyak",
                  target: clinic[index].HayyakTarget,
                  achieved_percentage: clinic[index].HayyakAchievedPercentage,
                  color: productColors.Hayyak,
                },
                {
                  value: clinic[index].HBBSales,
                  name: "HBB",
                  target: clinic[index].HBBTarget,
                  achieved_percentage: clinic[index].HBBAchievedPercentage,
                  color: productColors.HBB,
                },
                {
                  value: clinic[index].UpgradeSales,
                  name: "Upgrade",
                  target: clinic[index].UpgradeTarget,
                  achieved_percentage: clinic[index].UpgradeAchievedPercentage,
                  color: productColors.Upgrade,
                },
              ],
            };
            count++;
            viewDetail.push(details);
          }
        }
        setViewData(viewDetail);
      }
    }
  }, [outletper, props.region]);

  const gotoOutletChart = (ev) => {
    const columnData = ev.target._dataItem?._dataContext || {};
    console.log("clicked on ", ev.target, columnData.country);
    props.onSelect(columnData.country);
    document.getElementById("employeeTargetId").scrollIntoView({
      behavior: "smooth",
    });
  };

  useLayoutEffect(() => {
    let container = am4core.create("chartdiv3451", am4core.Container);
    container.width = am4core.percent(100);
    container.height = am4core.percent(100);
    container.layout = "horizontal";

    let chart = container.createChild(am4charts.PieChart);

    chart.data = viewData;

    let pieSeries = chart.series.push(new am4charts.PieSeries());
    pieSeries.dataFields.value = "litres";
    pieSeries.dataFields.category = "country";
    pieSeries.slices.template.states.getKey("active").properties.shiftRadius =
      0;
    pieSeries.slices.template.tooltipText =
      "Outlet: {country}\nTarget: {target}\nSales: {litres}\nAchievement: {achieved_percentage}%";
    pieSeries.slices.template.propertyFields.fill = "color";
    pieSeries.slices.template.events.on("hit", function (event) {
      selectSlice(event.target.dataItem);
    });
    pieSeries.labels.template.text = "{country}";
    pieSeries.labels.template.events.on("hit", gotoOutletChart);

    let chart2 = container.createChild(am4charts.PieChart);
    chart2.width = am4core.percent(30);
    chart2.radius = am4core.percent(80);

    let pieSeries2 = chart2.series.push(new am4charts.PieSeries());
    pieSeries2.dataFields.value = "value";
    pieSeries2.dataFields.category = "name";
    pieSeries2.slices.template.states.getKey("active").properties.shiftRadius =
      0;
    pieSeries2.labels.template.disabled = true;
    pieSeries2.ticks.template.disabled = true;
    pieSeries2.alignLabels = false;
    pieSeries2.events.on("positionchanged", updateLines);
    pieSeries2.slices.template.tooltipText =
      "Product: {name}\nTarget: {target}\nSales: {value}\nAchievement: {achieved_percentage}%";
    pieSeries2.slices.template.propertyFields.fill = "color";

    let interfaceColors = new am4core.InterfaceColorSet();

    let line1 = container.createChild(am4core.Line);
    line1.strokeDasharray = "2,2";
    line1.strokeOpacity = 0.5;
    line1.stroke = interfaceColors.getFor("alternativeBackground");
    line1.isMeasured = false;

    let line2 = container.createChild(am4core.Line);
    line2.strokeDasharray = "2,2";
    line2.strokeOpacity = 0.5;
    line2.stroke = interfaceColors.getFor("alternativeBackground");
    line2.isMeasured = false;

    let selectedSlice;

    function selectSlice(dataItem) {
      if (!dataItem || !dataItem.dataContext || !dataItem.dataContext.subData) {
        return;
      }

      selectedSlice = dataItem.slice;

      let fill = selectedSlice.fill;

      let count = dataItem.dataContext.subData.length;
      pieSeries2.colors.list = [];
      for (var i = 0; i < count; i++) {
        pieSeries2.colors.list.push(fill.brighten((i * 2) / count));
      }

      chart2.data = dataItem.dataContext.subData;
      pieSeries2.appear();

      let middleAngle = selectedSlice.middleAngle;
      let firstAngle = pieSeries.slices.getIndex(0).startAngle;
      let animation = pieSeries.animate(
        [
          { property: "startAngle", to: firstAngle - middleAngle },
          { property: "endAngle", to: firstAngle - middleAngle + 360 },
        ],
        600,
        am4core.ease.sinOut,
      );
      animation.events.on("animationprogress", updateLines);
      selectedSlice.events.on("transformed", updateLines);
    }

    function updateLines() {
      if (selectedSlice) {
        let p11 = {
          x: selectedSlice.radius * am4core.math.cos(selectedSlice.startAngle),
          y: selectedSlice.radius * am4core.math.sin(selectedSlice.startAngle),
        };
        let p12 = {
          x:
            selectedSlice.radius *
            am4core.math.cos(selectedSlice.startAngle + selectedSlice.arc),
          y:
            selectedSlice.radius *
            am4core.math.sin(selectedSlice.startAngle + selectedSlice.arc),
        };

        p11 = am4core.utils.spritePointToSvg(p11, selectedSlice);
        p12 = am4core.utils.spritePointToSvg(p12, selectedSlice);

        let p21 = { x: 0, y: -pieSeries2.pixelRadius };
        let p22 = { x: 0, y: pieSeries2.pixelRadius };

        p21 = am4core.utils.spritePointToSvg(p21, pieSeries2);
        p22 = am4core.utils.spritePointToSvg(p22, pieSeries2);

        line1.x1 = p11.x;
        line1.x2 = p21.x;
        line1.y1 = p11.y;
        line1.y2 = p21.y;

        line2.x1 = p12.x;
        line2.x2 = p22.x;
        line2.y1 = p12.y;
        line2.y2 = p22.y;
      }
    }

    chart.events.on("datavalidated", function () {
      setTimeout(function () {
        selectSlice(pieSeries.dataItems.getIndex(0));
      }, 1000);
    });

    return () => {
      chart.dispose();
    };
  }, [viewData]);

  return (
    <div
      style={{
        width: "100%",
        fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
        background: "#f7f8fc",
        borderRadius: 16,
        padding: "28px 24px",
      }}
    >
      {/* Card Header */}
      <div style={{ marginBottom: 20 }}>
        <div
          style={{
            fontSize: 11,
            fontWeight: 600,
            color: "#aaa",
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            marginBottom: 4,
          }}
        >
          {isMyPerformance ? "My Performance" : "Staff Performance"}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ fontSize: 24, fontWeight: 700, color: "#1a1a2e" }}>
            Outletwise — Target vs Achievement
          </div>
          {selectedRegion ? (
            <div
              style={{
                fontSize: 16,
                fontWeight: 600,
                color: "#555",
              }}
            >
              Region — {selectedRegion}
            </div>
          ) : null}
        </div>
      </div>

      {/* White card wrapping the chart */}
      <div
        style={{
          background: "#fff",
          borderRadius: 14,
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          padding: "24px 16px",
        }}
      >
        <div id="chartdiv3451" style={{ width: "100%", height: "400px" }} />
      </div>
    </div>
  );
}
